import { AtributosProperties } from "src/components/componentes/atributos/BaseAtributos";
import { DateUtil } from "./DateUtils";
import { Formater, TypeRecords } from "./Formater";
import { AtributosDef, Enum, TIPO_ATRIBUTO } from "./types";

class ComponentUtil {
  static keyGen(salt?: string): string {
    const _salt = salt ? salt : "";

    const now = DateUtil.nowDate();
    const random = Math.random() * 1000;

    return btoa(`${_salt}${random * now.getUTCMilliseconds()}`);
  }

  static getTypeRecord = (attrDef: AtributosDef | undefined): TypeRecords => {
    if (attrDef === undefined) {
      return TypeRecords.TEXT;
    }
    switch (attrDef.tipo) {
      case TIPO_ATRIBUTO.DECIMAL:
        if (attrDef.precisao === 2) {
          return TypeRecords.DECIMAL2;
        }

        if (attrDef.precisao === 3) {
          return TypeRecords.DECIMAL3;
        }

        return TypeRecords.DECIMAL1;
      case TIPO_ATRIBUTO.INTEIRO:
        return TypeRecords.INT;
    }

    return TypeRecords.TEXT;
  };

  static findAttrDef(
    attr_id: string,
    atributosDefComponentes: AtributosDef[]
  ): AtributosDef | undefined {
    return atributosDefComponentes.find(
      (attr: AtributosDef) => attr.id === attr_id
    );
  }

  static parseValue(
    typeRecord: TypeRecords,
    attr: AtributosDef | undefined,
    props: AtributosProperties,
    idx: string
  ) {
    let value: any = "";
    if (attr) {
      if (attr.multiplo) {
        const valores = JSON.parse(JSON.stringify(attr?.valores?.enum || []));
        let val: any = [];
        if (props && !!props?.atributos && !!props?.atributos[attr.id]) {
          val = props?.atributos[attr.id].toString().split(",");
          val =
            valores.filter((f: any) => {
              return val.includes(f.value.toString());
            }) || [];
        }
        const multiValue = val.map((v: any) => v.text);
        return multiValue?.join(", ");
      }
    }

    switch (typeRecord) {
      case TypeRecords.INT:
      case TypeRecords.DECIMAL1:
      case TypeRecords.DECIMAL2:
      case TypeRecords.DECIMAL3:
      case TypeRecords.PERCENT2:
      case TypeRecords.PERCENT3:
      case TypeRecords.CURRENCY:
        value = attr?.valor_padrao ? attr.valor_padrao : 0;
        break;

      case TypeRecords.TEXT:
        break;
      default:
        break;
    }

    value = Formater.toString(props.atributos[idx] || value, typeRecord);

    if (attr?.subtipo) {
      if (attr.subtipo === 2) {
        const valorEnum: Enum | undefined = attr.valores?.enum.find(
          (_enum: Enum) => _enum.value === parseInt(value)
        );

        value = valorEnum ? valorEnum.text : "não informado";
      }
    }

    value = `${value}${attr?.sufixo ? " " + attr.sufixo : ""}`;
    return value;
  }

  static fitHeigthSize(selector: string): number {
    let heigth: number = 0;

    const el = document.querySelector(selector);

    heigth = window.screen.height - (el?.getBoundingClientRect()?.top || 0);

    return heigth - window.screen.height * 0.1;
  }

  static getListPersist<T>(oldData: T[], newData: T[], fieldId: string): { data: T[], removedData: T[] } {
    const oldDataCustom: T[] = oldData || [];
    const newDataCustom: T[] = [...newData];
    const newDataCustomIds: any = newDataCustom.map((e: any) => e[fieldId]) || [];
    const removedDataCustom: T[] = oldDataCustom.filter(
      (e: any) => !newDataCustomIds.includes(e[fieldId])
    );

    return {
      data: newDataCustom,
      removedData: removedDataCustom,
    }
  }



}

export { ComponentUtil };
